<template>
  <div>
    <b-navbar :class="{'navbar-mobile':$uiHelpers.isMobile }" class="navbar position-absolute">
      <b-navbar-brand href="/opensaludprime"><img class="navbar-brand-img-bigger" src="/static-appopensalud/img/logos/primesalud_blue_02.svg"/></b-navbar-brand>
      <b-navbar-nav class="outside-collapse">
        <lang-selector :enablePortuguese="true" :class="{'flex-mobile-lang':$uiHelpers.isMobile, 'mr-4':!$uiHelpers.isMobile }"></lang-selector>
        <b-nav-item  v-if="!$uiHelpers.isMobile" class="my-auto">
          <base-button blue @click="$helpers.goToSection('medic-assistance')"><span>{{ $t('more-info-btn') }}</span> <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" class="ml-2" color="white"/></base-button>
        </b-nav-item>   
      </b-navbar-nav>
    </b-navbar>
    <opensaludpass-main-block></opensaludpass-main-block>
    <health-happiness-and-rest></health-happiness-and-rest>
    <medical-assistance></medical-assistance>
    <open-salud-wellness></open-salud-wellness>
    <open-salud-discounts></open-salud-discounts>
    <neu-cards-slider-pricing-prime id="pricing-prime" class="section" :white="true" :cards="cardsPricing2" :cards2="cardsPricing" :cards3="cardsPricing3" :title="$t('pricing.title')"></neu-cards-slider-pricing-prime>
    <companies-contact-form forIndividualsOnly platform="Opensaludprime" productName="Opensaludprime" callbackPath="/opensaludprime/gracias"></companies-contact-form>
  </div>
</template>

<script>
import LangSelector from '@/components/base/LangSelector.vue'
import { BNavbar, BNavbarBrand, BNavbarNav } from 'bootstrap-vue'
import OpensaludpassMainBlock from '@/components/public/OpensaludpassMainBlock'
import MedicalAssistance from '@/components/public/MedicalAssistance'
import PrimesaludPriceCards from '@/components/public/PrimesaludPriceCards'
import NeuCardsSlider from '@/components/base/ui/NeuCardsSlider'
import OpenSaludWellness from '@/components/public/OpenSaludWellness'
import OpenSaludDiscounts from '@/components/public/OpenSaludDiscounts'
import 'vuetify/dist/vuetify.min.css'
import CompaniesContactForm from '@/components/forms/CompaniesContactForm'
import HealthHappinessAndRest from '../../public/HealthHappinessAndRest.vue'
import NeuCardsSliderPricingPrime from '../../base/ui/NeuCardsSliderPricingPrime.vue'

export default {
  components: {
    LangSelector,
    BNavbar,
    BNavbarBrand,
    BNavbarNav,
    CompaniesContactForm,
    OpensaludpassMainBlock,
    MedicalAssistance,
    PrimesaludPriceCards,
    OpenSaludWellness,
    OpenSaludDiscounts,
    NeuCardsSlider,
    HealthHappinessAndRest,
    NeuCardsSliderPricingPrime
  },
  data () {
    return {
      cardsPricing: [
        {
          title: this.$t('familiar.title'),
          priceTitle: '12,95€',
          text: this.$t('familiar.text'),
          subtitle: this.$t('familiar.subtitle1'),
          subtitle1: this.$t('familiar.subtitle2'),
          subtitle2: this.$t('familiar.subtitle'),
          id: 'familiar'
        }
      ],
      cardsPricing2: [
        {
          title: this.$t('healthmind.title'),
          priceTitle: this.$t('healthmind.pricing'),
          text: this.$t('healthmind.text'),
          subtitle: this.$t('healthmind.subtitle'),
          subtitle1: this.$t('healthmind.subtitle1'),
          subtitle2: '',
          id: 'healthmind'
        }
      ],
      cardsPricing3: [
        {
          title: 'SINGLE',
          priceTitle: '8,95€',
          text: this.$t('familiar.text'),
          subtitle: this.$t('familiar.subtitle1'),
          subtitle1: this.$t('familiar.subtitle2'),
          subtitle2: this.$t('familiar.subtitlesingle'),
          id: 'single'
        }
      ],
      cards: [
        {
          title: this.$t('cards.1.title'),
          subtitle: this.$t('cards.1.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/NEU_ICON_STAR.svg'
        },
        {
          title: this.$t('cards.2.title'),
          subtitle: this.$t('cards.2.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/NEU_ICON_PRICE.svg'
        },
        {
          title: this.$t('cards.3.title'),
          subtitle: this.$t('cards.3.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/NEU_ICON_LOCK.svg'
        }
      ]
    }
  },
  mounted () {
    /* let gtagScript = document.createElement('script')
    gtagScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-MNCV80RN1Y')
    document.head.appendChild(gtagScript)
    let gtagLocalScript = document.createElement('script')
    gtagLocalScript.setAttribute('src', '/plugins/gtag-primesalud.js')
    document.head.appendChild(gtagLocalScript) */
  }
}
</script>

<style lang="scss" scoped>
 /deep/{ @import "static-appopensalud/css/public/views/opensalud_profesionales.scss";}
  
 .neu-cards-slider {
    @include media(mobile, tablets) {
      .row {
        display: block;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;

        [class*="col-"] {
          display: inline-block;
          width: 100%;
        }
      }
    }


    .card-ctn2 {
      display: block !important;

      @include desktop {
        padding: 0 2rem;
      }
      @include desktop-sm {
        padding: 0 2rem;
      }
      @include tablets {
        padding: 0;
      }
      @include media(tablets, mobile) {
        margin-right: 0rem !important;
        padding-right: 4rem;
        padding-left: 4rem;
        padding-top: 4rem;
        padding-bottom: 2rem;
      }

      .neu-card {
        display: block;
            transition-duration: 9999999s;
            justify-content:center ;
        &:hover {
            @include desktop {
                padding: 5rem;
            }
            @include desktop-sm {
              padding: 0rem 5rem;
            }
      
      transition-duration: 999999999s;
      }
        @include desktop {
          padding: 5rem;
          height: 400px;
          width: 320px;
        }
        @include desktop-sm {
          padding: 0rem 5rem;
          height: 400px;
          width: 320px;
        }

        @include tablets {
          padding: 7rem;
          width: 100%;
          max-width: none;

          span {
            margin: auto;
          }
        }

        @include mobile {
          padding: 5rem 3rem;
          margin-bottom: 3rem;
          min-height: 280px;
        }
      }
      
    }
  }
.nav-mobile{
  @include mobile(){
    padding: 1rem 0rem !important
  }
}
.section {
  @include section;
  min-height: 100vh;
}
.navbar-brand-img-bigger {
  width: 240px;
	@include tablets {
		width: 190px;
	}

  @include mobile(){
      width: 169px;
  }
}

@include tablets {
    ul.navbar-nav {
      background-color: transparent !important;
      box-shadow: none !important;
    }
}
.flex-mobile-lang {
  display:inline-flex !important;
}
// Black section with full column image
.section-invert {
  @include section;
  background-color: $black;

  h3 {
    color: $white;
  }

  .content {
    @include container-padding;

    @include desktop {
      padding: {
        top: 4rem;
        bottom: 4rem;
      }
    }

  }

  .subtitle {
    @include desktop-sm {
      width: 100% !important;
    }

    p {
      color: $gray;
    }

    span {
      color: $gray
    }
    .subtitle-list {
      &.subtitle-list-large {
        p {
          color: $white;
          margin-top: 0 !important;
          margin-bottom: 0 !important;
        }
      }
      &:not(.subtitle-list-large) {
        span {
          color: $white;
        }
      }
      span {
        font-size: 1.25rem;
        display: inline-block;
      }
      > div {
        margin-bottom: 1rem;
        color: $white;
        > span {
          font-size: 1.5rem;
        }
      }
    }
  }

  .col-bg {
    width: 100%;
  }
}

/deep/ {
	 .v-icon {
		color: $gray;
		margin-right: 1rem;
	}

	.btn-more-info-white {
		margin-top: 1rem;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/views/opensalud/Opensaludpass.vue